import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotifications = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_425_2934",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 40,
		height: 40,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_425_2934)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8.05538 31.6667C7.66188 31.6667 7.33202 31.5331 7.0658 31.266C6.7996 30.9989 6.6665 30.6679 6.6665 30.273C6.6665 29.8781 6.7996 29.5487 7.0658 29.2848C7.33202 29.0209 7.66188 28.889 8.05538 28.889H9.99984V16.5556C9.99984 14.2315 10.6897 12.1551 12.0693 10.3264C13.4489 8.49772 15.2591 7.33337 17.4998 6.83337V5.83337C17.4998 5.13893 17.7429 4.54865 18.229 4.06254C18.7151 3.57643 19.3054 3.33337 19.9998 3.33337C20.6943 3.33337 21.2846 3.57643 21.7707 4.06254C22.2568 4.54865 22.4998 5.13893 22.4998 5.83337V6.83337C24.7406 7.33337 26.5508 8.49772 27.9304 10.3264C29.31 12.1551 29.9998 14.2315 29.9998 16.5556V28.889H31.9443C32.3378 28.889 32.6677 29.0225 32.9339 29.2897C33.2001 29.5568 33.3332 29.8878 33.3332 30.2827C33.3332 30.6776 33.2001 31.007 32.9339 31.2709C32.6677 31.5348 32.3378 31.6667 31.9443 31.6667H8.05538ZM19.9998 36.6667C19.0832 36.6667 18.2984 36.3403 17.6457 35.6875C16.9929 35.0348 16.6665 34.25 16.6665 33.3334H23.3332C23.3332 34.25 23.0068 35.0348 22.354 35.6875C21.7012 36.3403 20.9165 36.6667 19.9998 36.6667ZM12.7776 28.889H27.2221V16.5556C27.2221 14.5556 26.5184 12.8519 25.111 11.4445C23.7035 10.0371 21.9998 9.33337 19.9998 9.33337C17.9998 9.33337 16.2961 10.0371 14.8887 11.4445C13.4813 12.8519 12.7776 14.5556 12.7776 16.5556V28.889Z",
			fill: "#778521"
		})
	})]
});
export default SvgNotifications;
